module.exports = __webpack_public_path__ + "static/media/logo-myoderm-header-white.4e949a28.svg";